/**
 * Top-level router `errorElement`. Renders a minimal fallback for unexpected
 * render/loader errors so a thrown error doesn't blank the whole app.
 */
import { useEffect, useRef } from 'react';
import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, Link as RouterLink, useRouteError } from 'react-router-dom';
import { SkipLink } from '@/components/SkipLink';
import { HOME_PATH } from '@/routes/home';

export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const headingRef = useRef<HTMLHeadingElement>(null);
  let message = t('errors.generic');
  if (isRouteErrorResponse(error)) {
    message = `${error.status} ${error.statusText}`;
  }
  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
  }, []);
  return (
    <>
      <SkipLink />
      <main
        id="main"
        tabIndex={-1}
        style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}
      >
        <div role="alert">
          <h1 ref={headingRef} tabIndex={-1}>
            {t('errors.unexpected')}
          </h1>
          <p>{message}</p>
        </div>
        <Link component={RouterLink} to={HOME_PATH}>
          {t('errors.returnHome')}
        </Link>
      </main>
    </>
  );
}
